"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormProps = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _flags = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flags"));
var _lodash = require("lodash");
var getFormProps = exports.getFormProps = function getFormProps(_ref) {
  var _enums$labels, _enums$labels2;
  var notificationPreferences = _ref.notificationPreferences,
    flags = (0, _flags.default)(_ref),
    enums = _ref.enums;
  var email = notificationPreferences.email,
    new_assistance_request = notificationPreferences.new_assistance_request,
    new_incoming_referral = notificationPreferences.new_incoming_referral,
    referral_accepted = notificationPreferences.referral_accepted,
    referral_closed = notificationPreferences.referral_closed,
    referral_declined = notificationPreferences.referral_declined,
    referral_held_for_review = notificationPreferences.referral_held_for_review,
    referral_new_note = notificationPreferences.referral_new_note,
    remind_sent_referrals = notificationPreferences.remind_sent_referrals,
    remind_received_referrals = notificationPreferences.remind_received_referrals,
    remind_service_cases = notificationPreferences.remind_service_cases,
    new_invoice = notificationPreferences.new_invoice,
    _notificationPreferen = notificationPreferences.in_app,
    task_new = _notificationPreferen.task_new,
    task_due = _notificationPreferen.task_due,
    task_overdue = _notificationPreferen.task_overdue,
    task_assigned = _notificationPreferen.task_assigned,
    invoice_received = notificationPreferences.invoice_received,
    invoice_accepted = notificationPreferences.invoice_accepted,
    invoice_paid = notificationPreferences.invoice_paid,
    invoice_rejected = notificationPreferences.invoice_rejected,
    invoice_under_dispute = notificationPreferences.invoice_under_dispute,
    invoice_dispute_resolved = notificationPreferences.invoice_dispute_resolved,
    fee_schedule_program = notificationPreferences.fee_schedule_program,
    export_completed = notificationPreferences.export_completed,
    accepted_informed_consent = notificationPreferences.accepted_informed_consent,
    care_coordinator_assigned = notificationPreferences.care_coordinator_assigned,
    case_status_change = notificationPreferences.case_status_change,
    contact_case_new_note = notificationPreferences.contact_case_new_note,
    contact_new_note = notificationPreferences.contact_new_note,
    declined_informed_consent = notificationPreferences.declined_informed_consent,
    primary_worker_assigned_to_case = notificationPreferences.primary_worker_assigned_to_case,
    enrollment_request = notificationPreferences.enrollment_request,
    social_care_coverage_ended = notificationPreferences.social_care_coverage_ended,
    program_accepting_referrals = notificationPreferences.program_accepting_referrals,
    program_not_accepting_referrals = notificationPreferences.program_not_accepting_referrals,
    messaging_notification = notificationPreferences.messaging_notification,
    service_authorization_requested = notificationPreferences.service_authorization_requested,
    service_authorization_approved = notificationPreferences.service_authorization_approved,
    service_authorization_denied = notificationPreferences.service_authorization_denied;
  var showPayerInvoices = flags.showPayerInvoices,
    showEnrollment = flags.showEnrollment,
    showPayment = flags.showPayment,
    hasOrgAdmin = flags.hasOrgAdmin,
    isPayerAuthorizationUser = flags.isPayerAuthorizationUser,
    isCareManager = flags.isCareManager,
    showInvoice = flags.showInvoice;
  var overallProps = [{
    label: 'Allow any emails',
    name: 'email',
    value: email
  }];
  var clientProps = (0, _lodash.compact)([{
    label: 'Client provides consent',
    name: 'accepted_informed_consent',
    value: accepted_informed_consent
  }, {
    label: 'Client declines consent',
    name: 'declined_informed_consent',
    value: declined_informed_consent
  }, {
    label: 'Note added to client profile',
    name: 'contact_new_note',
    value: contact_new_note
  }, enums !== null && enums !== void 0 && (_enums$labels = enums.labels) !== null && _enums$labels !== void 0 && _enums$labels.CareCoordinator ? {
    label: "You are assigned as ".concat(enums === null || enums === void 0 || (_enums$labels2 = enums.labels) === null || _enums$labels2 === void 0 ? void 0 : _enums$labels2.CareCoordinator),
    name: 'care_coordinator_assigned',
    value: care_coordinator_assigned
  } : null]);
  var referralProps = [{
    label: 'New assistance request received',
    name: 'new_assistance_request',
    value: new_assistance_request
  }, {
    label: 'New referral sent to your organization',
    name: 'new_incoming_referral',
    value: new_incoming_referral
  }, {
    label: 'Note added to sent referral/case',
    name: 'referral_new_note',
    value: referral_new_note
  }, {
    label: 'Sent referral is accepted',
    name: 'referral_accepted',
    value: referral_accepted
  }, {
    label: 'Sent referral is held for review',
    name: 'referral_held_for_review',
    value: referral_held_for_review
  }, {
    label: 'Sent referral is rejected',
    name: 'referral_declined',
    value: referral_declined
  }, {
    label: 'Sent referral is closed',
    name: 'referral_closed',
    value: referral_closed
  }, {
    label: 'Case has note added',
    name: 'contact_case_new_note',
    value: contact_case_new_note
  }, {
    label: 'You are assigned as primary worker',
    name: 'primary_worker_assigned_to_case',
    value: primary_worker_assigned_to_case
  }, {
    label: 'Case closed',
    name: 'case_status_change',
    value: case_status_change
  }];
  var messageProps = [{
    label: 'New message received from a Unite Us user',
    name: 'messaging_notification',
    value: messaging_notification
  }];
  var paymentProps = [{
    label: 'Enrollment request received or updated',
    name: 'enrollment_request',
    value: enrollment_request
  }, {
    label: 'Social care coverage has ended',
    name: 'social_care_coverage_ended',
    value: social_care_coverage_ended
  }, {
    label: 'Authorization request received',
    name: 'service_authorization_requested',
    value: service_authorization_requested
  }, {
    label: 'Authorization request is approved',
    name: 'service_authorization_approved',
    value: service_authorization_approved
  }, {
    label: 'Authorization request is denied',
    name: 'service_authorization_denied',
    value: service_authorization_denied
  }, {
    label: 'New invoice',
    name: 'new_invoice',
    value: new_invoice
  }, {
    label: 'New invoice',
    name: 'invoice_received',
    value: invoice_received
  }, {
    label: 'Invoice accepted by payer',
    name: 'invoice_accepted',
    value: invoice_accepted
  }, {
    label: 'Invoice paid',
    name: 'invoice_paid',
    value: invoice_paid
  }, {
    label: 'Invoice rejected',
    name: 'invoice_rejected',
    value: invoice_rejected
  }, {
    label: 'Invoice disputed',
    name: 'invoice_under_dispute',
    value: invoice_under_dispute
  }, {
    label: showPayerInvoices ? 'Invoice dispute resolved' : 'Resolved disputed invoice',
    name: 'invoice_dispute_resolved',
    value: invoice_dispute_resolved
  }, {
    label: 'Invoice export file ready to download',
    name: 'export_completed',
    value: export_completed
  }, {
    label: 'Contracted program is updated',
    name: 'fee_schedule_program',
    value: fee_schedule_program
  }].reduce(function (acc, prop) {
    if (prop.name === 'enrollment_request' && (showEnrollment || showPayment) && !showPayerInvoices) {
      return [].concat((0, _toConsumableArray2.default)(acc), [prop]);
    }
    if (prop.name === 'social_care_coverage_ended' && hasOrgAdmin && showPayment) {
      return [].concat((0, _toConsumableArray2.default)(acc), [prop]);
    }
    if (prop.name === 'service_authorization_requested' && isPayerAuthorizationUser && !showPayerInvoices) {
      return [].concat((0, _toConsumableArray2.default)(acc), [prop]);
    }
    if (prop.name === 'service_authorization_approved' && isCareManager) {
      return [].concat((0, _toConsumableArray2.default)(acc), [prop]);
    }
    if (prop.name === 'service_authorization_denied' && isCareManager) {
      return [].concat((0, _toConsumableArray2.default)(acc), [prop]);
    }
    if (prop.name === 'new_invoice' && showInvoice && !showPayerInvoices) {
      return [].concat((0, _toConsumableArray2.default)(acc), [prop]);
    }
    if (prop.name === 'invoice_received' && showPayerInvoices) {
      return [].concat((0, _toConsumableArray2.default)(acc), [prop]);
    }
    if (prop.name === 'invoice_accepted' && showInvoice && !showPayerInvoices) {
      return [].concat((0, _toConsumableArray2.default)(acc), [prop]);
    }
    if (prop.name === 'invoice_paid' && showInvoice && !showPayerInvoices) {
      return [].concat((0, _toConsumableArray2.default)(acc), [prop]);
    }
    if (prop.name === 'invoice_rejected' && showInvoice && !showPayerInvoices) {
      return [].concat((0, _toConsumableArray2.default)(acc), [prop]);
    }
    if (prop.name === 'invoice_under_dispute' && (showInvoice || showPayerInvoices)) {
      return [].concat((0, _toConsumableArray2.default)(acc), [prop]);
    }
    if (prop.name === 'invoice_dispute_resolved' && (showInvoice || showPayerInvoices)) {
      return [].concat((0, _toConsumableArray2.default)(acc), [prop]);
    }
    if (prop.name === 'export_completed' && (showInvoice || showPayerInvoices)) {
      return [].concat((0, _toConsumableArray2.default)(acc), [prop]);
    }
    if (prop.name === 'fee_schedule_program' && hasOrgAdmin && (showPayment || showInvoice)) {
      return [].concat((0, _toConsumableArray2.default)(acc), [prop]);
    }
    return acc;
  }, []);
  var reminderProps = [{
    label: 'Remind me when a referral that I received needs my action',
    name: 'remind_received_referrals',
    value: remind_received_referrals
  }, {
    label: 'Remind me when a referral that I sent requires action',
    name: 'remind_sent_referrals',
    value: remind_sent_referrals
  }, {
    label: 'Remind me when I have a case that needs to be updated',
    name: 'remind_service_cases',
    value: remind_service_cases
  }];
  var programProps = [{
    label: 'Program starts accepting referrals',
    name: 'program_accepting_referrals',
    value: program_accepting_referrals
  }, {
    label: 'Program stops accepting referrals',
    name: 'program_not_accepting_referrals',
    value: program_not_accepting_referrals
  }];
  var taskProps = [{
    label: 'New task added',
    name: 'task_new',
    value: task_new
  }, {
    label: 'Task due',
    name: 'task_due',
    value: task_due
  }, {
    label: 'Task overdue',
    name: 'task_overdue',
    value: task_overdue
  }, {
    label: 'Task assigned',
    name: 'task_assigned',
    value: task_assigned
  }];
  return {
    overallProps: overallProps,
    clientProps: clientProps,
    referralProps: referralProps,
    messageProps: messageProps,
    paymentProps: paymentProps,
    reminderProps: reminderProps,
    programProps: programProps,
    taskProps: taskProps
  };
};
//# sourceMappingURL=getFormProps.js.map